// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.buyer-info__item-input .sk-input__input {\n  height: 36px;\n  font-size: 14px;\n  line-height: 20px;\n}\n.buyer-info .post-section__title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.buyer-info .buyer-info__btn {\n  width: auto;\n  min-width: 50px;\n  padding: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
